import {injectable} from "inversify";
import {LineupEnum} from "@/modules/base/enums";
import {Player, Team} from "@/modules/team/entity";
import AbstractLineupper from "@/modules/ai/services/lineupper/AbstractLineupper";
import {Match} from "@/modules/match/entity";
import {BeforeLineupChangedEndEvent} from "@/modules/team/events/BeforeLineupChangedEndEvent";
import {AfterLineupChangedEndEvent} from "@/modules/team/events/AfterLineupChangedEndEvent";

@injectable()
export default class RandomLineupper extends AbstractLineupper {
  async lineup(team: Team, nextMatch?: Match) {
    await this.em.emitAsync(new BeforeLineupChangedEndEvent);

    await super.lineup(team);

    let players = collect(team.players);

    if (nextMatch) {
      players = players
        .filter(player => !player.suspensions.find(s => s.competitionId === nextMatch.matchday.division.competitionId));
    }

    await players
      .shuffle()
      .take(11)
      .toArray()
      .forEachAsync(async (player: Player, index: number) => {
        player.lineup = index + 1 as LineupEnum;
        await player.save();
      });
    
    await this.em.emitAsync(new AfterLineupChangedEndEvent);
  }
}
